import React, { FC, Fragment, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { setErrorToast } from '../../../store/toast';
import { monthList } from '../helpers';
import { ETabDataPicker } from '../index';
import ISelectDatepicker from '../SelectDatepicker';

const MonthSelect: FC<ISelectDatepicker.IPropsSelectedItem> = ({
  handleChange,
  dateSelected,
  minDate,
  tabSelected,
  isMaxDateCurrent,
}) => {
  const dispatch = useDispatch();

  return (
    <Fragment>
      {useMemo(
        () =>
          monthList().map((monthItem) => {
            const disable =
              (dateSelected &&
                moment(dateSelected).year() === moment(minDate).year() &&
                moment(monthItem, 'MMMM').month() < moment(minDate).month()) ||
              (isMaxDateCurrent &&
                moment(dateSelected).year() === moment(new Date()).year() &&
                moment(monthItem, 'MMMM').month() > moment(new Date()).month());

            return (
              <div
                key={monthItem}
                className={`tw-text-[12px] tw-text-center tw-text-gray200 tw-border tw-flex tw-items-center tw-justify-center 
             
             ${
               disable
                 ? 'tw-text-gray600 tw-cursor-not-allowed'
                 : 'tw-cursor-pointer hover:tw-text-green500 '
             }
             ${
               tabSelected[ETabDataPicker.MONTH] &&
               moment(dateSelected).format('MMMM') === monthItem
                 ? 'tw-border-green500 tw-text-green500 tw-rounded-md'
                 : 'tw-border-transparent'
             }`}
                onClick={() => {
                  if (disable) {
                    return dispatch(
                      setErrorToast({
                        title: '',
                        message: 'The selected month cannot be selected',
                      }),
                    );
                  }
                  handleChange(ETabDataPicker.MONTH, monthItem);
                }}
              >
                {monthItem}
              </div>
            );
          }),
        [dateSelected],
      )}
    </Fragment>
  );
};

export default MonthSelect;
